import React, { useState, useEffect } from "react";
import { Table, Button, Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const BASE_URL = "https://dailydish.in/api";

const KarlePlaceOrder = () => {
  const karleAdmin = JSON.parse(localStorage.getItem("karleAdmin") || "null");

  const [orderDate, setOrderDate] = useState(null);
  const [menu, setMenu] = useState([]);
  const [qtyMap, setQtyMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getForm = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${BASE_URL}/karle/orders/form`, {
        params: { karleAdminId: karleAdmin?._id },
      });
      if (res.data.success) {
        const { orderDate, menu, existingOrder } = res.data.data;
        setOrderDate(orderDate);
        setMenu(menu);

        const initialQty = {};
        if (existingOrder) {
          existingOrder.items.forEach((it) => {
            initialQty[String(it.karleProductId)] = it.qty;
          });
        }
        setQtyMap(initialQty);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load menu");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!karleAdmin?._id) return;
    getForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQtyChange = (productId, value) => {
    setQtyMap((prev) => ({ ...prev, [productId]: value }));
  };

  const total = menu.reduce((sum, m) => {
    const product = m.karleProductId;
    if (!product) return sum;
    const qty = Number(qtyMap[String(product._id)]) || 0;
    return sum + qty * product.karlePrice;
  }, 0);

  const submitOrder = async () => {
    try {
      const items = Object.entries(qtyMap)
        .filter(([, qty]) => Number(qty) > 0)
        .map(([karleProductId, qty]) => ({ karleProductId, qty: Number(qty) }));

      if (items.length === 0) {
        return toast.warning("Please enter a quantity for at least one item");
      }

      setIsSubmitting(true);
      const res = await axios.post(`${BASE_URL}/karle/orders/submit`, {
        karleAdminId: karleAdmin?._id,
        items,
      });
      if (res.status === 200) {
        toast.success("Order placed successfully");
        await getForm();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.error || "Error placing order");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!karleAdmin?._id) {
    return <p className="p-4">Please log in again.</p>;
  }

  return (
    <div className="p-2">
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar
        closeOnClick
        draggable
      />
      <h3 className="mb-1">Place Order</h3>
      <p style={{ color: "#888" }}>
        Ordering for:{" "}
        <strong>{orderDate ? new Date(orderDate).toDateString() : "-"}</strong>
      </p>

      {isLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="oranged" />
        </div>
      ) : (
        <>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Image</th>
                <th>Food Name</th>
                <th>Short Description</th>
                <th>Karle Price</th>
                <th>Quantity</th>
                <th>Line Total</th>
              </tr>
            </thead>
            <tbody>
              {menu.map((m) => {
                const product = m.karleProductId;
                if (!product) return null;
                const qty = qtyMap[String(product._id)] || "";
                return (
                  <tr key={product._id}>
                    <td>
                      <img
                        src={product.foodImage}
                        alt=""
                        style={{ width: 50, height: 50 }}
                      />
                    </td>
                    <td>{product.foodName}</td>
                    <td>{product.shortDescription}</td>
                    <td>₹{product.karlePrice}</td>
                    <td>
                      <input
                        type="number"
                        min="0"
                        className="form-control"
                        style={{ width: 90 }}
                        value={qty}
                        onChange={(e) =>
                          handleQtyChange(String(product._id), e.target.value)
                        }
                      />
                    </td>
                    <td>₹{(Number(qty) || 0) * product.karlePrice}</td>
                  </tr>
                );
              })}
              {menu.length === 0 && (
                <tr>
                  <td colSpan={6}>No items on the menu right now</td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <h5>Total: ₹{total}</h5>
            <Button
              variant="success"
              onClick={submitOrder}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="ms-2">Submitting...</span>
                </>
              ) : (
                "Submit Order"
              )}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default KarlePlaceOrder;
